@if (caseStoryItems.caseStoryItems.length < MINIMUM_SLIDER_ITEMS_ALLOWED_BY_UX) {
    <sirius-card-grid
        [title]="'page.caseStories' | translate"
        data-cy="few-cards-component"
        [cardSize]="'medium'"
        [items]="caseStoryItems.caseStoryItems"></sirius-card-grid>
} @else {
    <sirius-card-slider
        data-cy="many-cards-component"
        [title]="'page.caseStories' | translate"
        [items]="caseStoryItems.caseStoryItems"></sirius-card-slider>
}
